
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[brand]/on-demand-cart",
      function () {
        return require("private-next-pages/[brand]/on-demand-cart.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[brand]/on-demand-cart"])
      });
    }
  